import { request } from 'umi';
import { queryOfURL } from '@/utils/url';
import env from '@/utils/env';
import {
  IFetchCartSum,
  IApiPromiseResWithResult,
  IApiPromiseResWithList,
} from './commonTypes';

const { mock } = queryOfURL(location.search);
export const apiPrefix = mock ? '' : env.BLACKPEARL_HOST;
export const FD_API_HOST = mock ? '' : env.FD_API_HOST;
export const host = mock ? '' : env.NEIGHBOUR_API_HOST;
// export const apiPrefix = mock ? '' : 'http://10.39.228.156';

// 获取商品列表
export const fetchCartSum = (params: {
  project_code: string;
  region?: string;
  locate_address_id?: string;
  locate_project_code?: string;
  locate_region?: string;
}) => {
  return request<IFetchCartSum>(`${apiPrefix}/interfaces/cart/sum`, {
    method: 'GET',
    skipErrorHandler: false,
    params,
  });
};

// 提交评论
export const addComment = (data: {
  goods_id: string;
  item_id: string;
  order_id: string;
  score: number;
  supplier_id: string;
  content: {
    images: Array<any>;
    comment: string;
  };
}) => {
  return request(`${apiPrefix}/interfaces/feedback/add`, {
    method: 'POST',
    skipErrorHandler: false,
    data,
  }) as IApiPromiseResWithResult<{
    credits: number;
    status: number;
  }>;
};
// 获取评论标签
export const fetchCommentTags = (data: {
  orderId: string | number;
  score: number;
}) => {
  return request(`${apiPrefix}/interfaces/feedback/tags`, {
    method: 'POST',
    skipErrorHandler: false,
    data,
  });
};

// 评论详情
export const getCommentDetail = (
  orderId: number,
  params: {
    project_code: string;
    order_id: number;
  },
) => {
  return request(`${apiPrefix}/interfaces/feedback/detail/${orderId}`, {
    method: 'GET',
    skipErrorHandler: false,
    params,
  });
};
// 获取待点评列表
export const getWaitCommentList = (params: {
  pageSize: number;
  pageNum: number;
}) => {
  return request(`${apiPrefix}/interfaces/feedback/continueFeedback`, {
    method: 'GET',
    skipErrorHandler: false,
    params,
  }) as IApiPromiseResWithList<
    {
      goodsOutputBoList: Array<{
        goodsId: string;
        goodsName: string;
        img: string;
        itemId: string;
        num: number;
        spec: Array<{
          key: string;
          type: string;
          value: string;
        }>;
      }>;
      orderId: number;
    }[]
  >;
};

// 友邻计划首页
export const getSunshineRank = (params: { project_code: string }) => {
  return request(`${apiPrefix}/interfaces/statistics/sunshine/ranking`, {
    method: 'GET',
    skipErrorHandler: false,
    params,
  });
};

// 社区排名
export const getCommunityRank = () => {
  return request(`${apiPrefix}/interfaces/statistics/sunshine/donors`, {
    method: 'GET',
    skipErrorHandler: false,
  });
};

// 获取新老用户登陆优惠券列表
export interface IGetNewOrOldUserLoginCouponsItem {
  status: number; // 1 未使用 2 已使用 3 已过期
  remark: string;
  rewardId: string;
  object: string;
  source: string;
  route: string;
  sourceName: null;
  title: string;
  rule: null;
  couponId: string;
  discount: string;
  exchangeCode: string;
  end_time: number;
  start_time: number;
  type: string; // 0 优惠券 专用券  1 代金券 金额（100） 2 折扣券 折扣（4.5折） 3 提货券 提货券
  condition: string;
  couponClass: 'NEW_USER' | 'OLD_USER';
}
export const getNewOrOldUserLoginCoupons = () => {
  return request(`${apiPrefix}/interfaces/coupon/reward/list`, {
    method: 'get',
    params: {
      resource: 'app',
    },
  }) as IApiPromiseResWithResult<IGetNewOrOldUserLoginCouponsItem[]>;
};

// 获取用户拥有的优惠券列表
export interface IGetUserOwnCouponsItem {
  status: number; // 1 未使用 2 已使用 3 已过期
  remark: string;
  object: string;
  source: string;
  route: string;
  sourceName: null;
  title: string;
  rule: null;
  couponId: string;
  discount: string;
  exchangeCode: string;
  end_time: number;
  start_time: number;
  type: number; // 0 优惠券 专用券  1 代金券 金额（100） 2 折扣券 折扣（4.5折） 3 提货券 提货券
  condition: string;
}
export const getUserOwnCoupons = () => {
  return request(`${apiPrefix}/interfaces/coupon/reward/all`, {
    method: 'get',
  }) as IApiPromiseResWithResult<IGetUserOwnCouponsItem[]>;
};

export const checkUserOwnCoupons = () => {
  return request(`${apiPrefix}/interfaces/coupon/reward/check`, {
    method: 'get',
  }) as IApiPromiseResWithResult<boolean>;
};

/**
 * 通知后台发放活动优惠券
 */
export const noticeSendCoupon = () => {
  return request(`${apiPrefix}/interfaces/coupon/reward/send`, {
    method: 'post',
  }) as IApiPromiseResWithResult<unknown>;
};

/**
 * 检测首页是否有广告弹窗
 */
export const checkHomeBannerModal = () => {
  return request(`${apiPrefix}/interfaces/coupon/homeDiaLog?source=APP`, {
    method: 'get',
  }) as IApiPromiseResWithResult<{
    popup: boolean;
    linkUrl: string;
  }>;
};

/**
 * 住这儿口令获取
 */
export const fetchZzrCopyCode = (data: {
  busCode: string;
  displayContent: string;
  pictureUrl: string;
  busName: string;
  jumpUrl: string;
}) => {
  return request(`${env.Z_HOST}/pop/api/code/generate`, {
    method: 'post',
    data,
    skipErrorHandler: true,
  }) as IApiPromiseResWithResult<string>;
};

/**
 * 住这儿口令获取
 */
export const fetchNewUserAlerted = ({
  pageMark,
  userId,
}: {
  pageMark: string;
  userId: string;
}) => {
  return request(
    `${host}/mephisto/interfaces/zze/newUser/alerted/${pageMark}/${userId}`,
    {
      method: 'get',
      skipErrorHandler: true,
    },
  ) as IApiPromiseResWithResult<string>;
};
